import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  items: [],
};

const getters = {
  allItems: (state) => state.items,
};

const actions = {
  async fetchItems({ commit }, params = {}) {
    try {
      commit("resetItems");
      const response = await axios.get("/item", { params: prm(params) });
      commit("setItems", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  },
  async createItem({ commit }, item) {
    try {
      const response = await axios.post("/item", item);
      commit("addItem", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create item:", error);
      throw error;
    }
  },
  async createBulkItem({ commit }, item) {
    try {
      const response = await axios.post("/bulk-create", item);
      commit("addItem", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create item:", error);
      throw error;
    }
  },
  async fetchItemById(_, id) {
    try {
      const response = await axios.get(`/item/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch item:", error);
      throw error;
    }
  },
  async updateItem({ commit }, item) {
    try {
      const response = await axios.put(`/item/${item.id}`, item);
      commit("updateItem", response.data);
    } catch (error) {
      console.error("Failed to update item:", error);
      throw error;
    }
  },
  async updateItemStatus({ commit }, { item, newStatus, outlet_id }) {
    try {
      const updatedItem = {
        is_active: newStatus,
        outlet_id: outlet_id
      };
      const response = await axios.put(`/item/${item.id}`, updatedItem);
      commit("updateItem", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update item status:", error);
      throw error;
    }
  },
  async deleteItemById({ commit }, id) {
    try {
      const response = await axios.delete(`/item/${id}`);
      commit("removeItem", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete item:", error);
      throw error;
    }
  },
};

const mutations = {
  setItems(state, items) {
    state.items = items.data; // Ensure this matches your API's response structure
  },
  addItem(state, item) {
    state.items.push(item);
  },
  updateItem(state, updatedItem) {
    const index = state.items.findIndex(
      (item) => item.id === updatedItem.id
    );
    if (index !== -1) {
      state.items.splice(index, 1, updatedItem);
    }
  },
  removeItem(state, id) {
    state.items = state.items.filter(
      (item) => item.id !== id
    );
  },
  resetItems(state) {
    state.items = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
